import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react"; // Importing this to make sure the tsc compiler doesn't yell at me

import { css } from "@styled-system/css";
import { ThemeProvider } from "emotion-theming";
import theme from "../data/theme";

const Theme = props => {
  return ___EmotionJSX(ThemeProvider, {
    theme: props.theme ? props.theme : theme
  }, props.children);
};

export { Theme, css };